import { PROVINCE_MAPPING } from '../constants'

class Project {
  constructor (obj) {
    // Location
    this.lat = obj.Latitude
    this.lon = obj.Longitude
    this.province = obj.StateProv
    this.provinceCode = PROVINCE_MAPPING[this.province] || ''
    this.jurisdiction = this.provinceCode.toUpperCase()

    // Ridings
    this._federalRidingName = obj.Federal_District
    this._provincialRidingName = obj.Prov_District
  }

  addProvincialRiding (riding) {
    this._provincialRiding = riding
  }

  addFederalRiding (riding) {
    this._federalRiding = riding
  }

  provincialRidingName () {
    return this._provincialRiding ? this._provincialRiding.name : this._provincialRidingName
  }

  federalRidingName () {
    return this._federalRiding ? this._federalRiding.name : this._federalRidingName
  }

  provincialRiding () {
    return this._provincialRiding
  }

  federalRiding () {
    return this._federalRiding
  }
}

export default Project



// WEBPACK FOOTER //
// ./src/models/Project.js